module.exports = __webpack_public_path__ + "img/bjtt.92a11c3d.png";